import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";

@Component({
    selector: 'related-data',
    templateUrl: '../../templates/partials/related-data-cleaner.html'
})

export class RelatedDataCleanerComponent implements OnInit {

    public cleanersTab: string = 'next';
    @Input() cleanerDoneServices;
    @Input() cleanerNextServices;
    constructor(private router: Router) { }

    public setTab(tab: string) {
        this.cleanersTab = tab;
    }

    public goToService(id: string){
        this.router.navigate(["/services",id]);
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/related-data-cleaner.component.ts